// frontend/src/pages/AccessPendingPage.js
// Pantalla que informa al usuario que ya autenticó con Entra, pero aún no tiene acceso local.

import React from 'react';
import { ExclamationTriangleIcon } from '@heroicons/react/24/solid';

function AccessPendingPage() {
  return (
    <div className="min-h-screen bg-slate-950 flex items-center justify-center p-6">
      <div className="max-w-xl w-full bg-slate-900 border border-slate-700 rounded-3xl p-8 text-center shadow-2xl">
        <div className="mx-auto h-14 w-14 rounded-2xl bg-amber-500/15 text-amber-300 flex items-center justify-center">
          <ExclamationTriangleIcon className="h-7 w-7" />
        </div>
        <h1 className="mt-6 text-3xl font-bold text-white">Acceso pendiente de aprobación</h1>
        <p className="mt-4 text-slate-300 text-lg leading-7">
          Ya iniciaste sesión con Microsoft Entra ID, pero tu usuario todavía no está creado o no tiene un rol asignado en la plataforma.
        </p>
        <p className="mt-4 text-slate-400">
          Pídele al administrador que te cree como usuario, registre tu correo y te asigne el rol correspondiente. Cuando eso ocurra, podrás entrar normalmente.
        </p>
      </div>
    </div>
  );
}

export default AccessPendingPage;